class KarbonivaTheme {
  constructor() {
    this.bindMenu();
    this.bindCart();
    this.bindQuickAdd();
    this.bindProductGallery();
  }

  bindCart() {
    document.addEventListener('submit', async (event) => {
      const form = event.target.closest('[data-cart-line]');
      if (!form) return;
      const trigger = event.submitter;
      if (!trigger || trigger.name !== 'quantity') return;
      event.preventDefault();
      const root = form.closest('[data-cart-section]');
      if (!root || this.cartBusy) return;
      const quantity = Number(trigger.value);
      const id = form.querySelector('[name="id"]').value;
      const sectionId = root.dataset.sectionId;
      const action = trigger.dataset.cartAction;
      const errorBox = root.querySelector('[data-cart-error]');
      errorBox.hidden = true;
      this.cartBusy = true;
      root.setAttribute('aria-busy', 'true');
      const controls = [...root.querySelectorAll('button')];
      const disabledState = controls.map(button => button.disabled);
      controls.forEach(button => { button.disabled = true; });
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id, quantity, sections: [sectionId], sections_url: root.dataset.cartUrl })
        });
        const cart = await response.json();
        if (!response.ok) throw new Error(typeof cart.description === 'string' ? cart.description : 'Adet değiştirilemedi. Stok durumunu kontrol ederek tekrar deneyin.');
        const html = cart.sections?.[sectionId];
        const parsed = html ? new DOMParser().parseFromString(html, 'text/html') : null;
        const updated = parsed?.querySelector('[data-cart-section]');
        // A successful cart change must never be repeated if section rendering fails.
        if (!updated) { window.location.assign(root.dataset.cartUrl); return; }
        root.replaceWith(updated);
        document.querySelectorAll('[data-cart-count]').forEach(badge => {
          badge.textContent = cart.item_count;
          badge.hidden = cart.item_count === 0;
          badge.closest('a')?.setAttribute('aria-label', `Sepet, ${cart.item_count} ürün`);
        });
        const row = [...updated.querySelectorAll('[data-line-key]')].find(item => item.dataset.lineKey === id);
        const focusTarget = row?.querySelector(`[data-cart-action="${action}"]:not(:disabled)`) || row?.querySelector('[data-cart-action]:not(:disabled)') || updated.querySelector('h1');
        if (focusTarget) { if (focusTarget.tagName === 'H1') focusTarget.tabIndex = -1; focusTarget.focus({ preventScroll: true }); }
        this.showToast(quantity === 0 ? 'Ürün sepetten kaldırıldı.' : 'Sepet güncellendi.');
      } catch (error) {
        errorBox.textContent = error.message || 'Sepet güncellenemedi. Lütfen tekrar deneyin.';
        errorBox.hidden = false;
      } finally {
        this.cartBusy = false;
        root.removeAttribute('aria-busy');
        controls.forEach((button, index) => { button.disabled = disabledState[index]; });
      }
    });
  }

  bindMenu() {
    const toggle = document.querySelector('[data-menu-toggle]');
    const panel = document.querySelector('[data-mobile-menu]');
    if (!toggle || !panel) return;

    const setOpen = (open) => {
      toggle.setAttribute('aria-expanded', String(open));
      toggle.setAttribute('aria-label', open ? 'Menüyü kapat' : 'Menüyü aç');
      panel.hidden = !open;
    };
    toggle.addEventListener('click', () => setOpen(panel.hidden));
    panel.addEventListener('click', (event) => { if (event.target.closest('a')) setOpen(false); });
    document.addEventListener('click', (event) => {
      if (!panel.hidden && !panel.contains(event.target) && !toggle.contains(event.target)) setOpen(false);
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !panel.hidden) { setOpen(false); toggle.focus(); }
    });
    window.matchMedia('(min-width: 991px)').addEventListener('change', (event) => {
      if (event.matches) setOpen(false);
    });
  }

  bindQuickAdd() {
    document.addEventListener('submit', async (event) => {
      const form = event.target.closest('.js-quick-add');
      if (!form) return;
      event.preventDefault();

      const button = form.querySelector('button[type="submit"]');
      const original = button.textContent;
      button.disabled = true;
      button.textContent = 'Ekleniyor…';

      try {
        const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        });
        if (!response.ok) throw new Error('Sepete eklenemedi');

        const cartResponse = await fetch(`${window.Shopify.routes.root}cart.js`);
        const cart = await cartResponse.json();
        document.querySelectorAll('[data-cart-count]').forEach((item) => {
          item.textContent = cart.item_count;
          item.hidden = cart.item_count === 0;
        });
        this.showToast('Ürün sepete eklendi.');
      } catch (error) {
        this.showToast('Bir sorun oluştu. Lütfen tekrar deneyin.');
      } finally {
        button.disabled = false;
        button.textContent = original;
      }
    });
  }

  bindProductGallery() {
    const gallery = document.querySelector('[data-product-gallery]');
    if (!gallery) return;

    const track = gallery.querySelector('[data-gallery-track]');
    const slides = [...gallery.querySelectorAll('[data-gallery-slide]')];
    const dots = [...document.querySelectorAll('[data-gallery-dot]')];
    const previous = gallery.querySelector('[data-gallery-prev]');
    const next = gallery.querySelector('[data-gallery-next]');
    const lightbox = document.querySelector('[data-image-lightbox]');
    const lightboxImage = lightbox?.querySelector('[data-lightbox-image]');
    let index = 0;
    let startX = 0;
    let dragX = 0;
    let dragging = false;
    let suppressClick = false;

    const goTo = (newIndex) => {
      index = Math.max(0, Math.min(slides.length - 1, newIndex));
      track.style.transition = '';
      track.style.transform = `translate3d(-${index * 100}%, 0, 0)`;
      slides.forEach((slide, slideIndex) => {
        const active = slideIndex === index;
        slide.setAttribute('aria-hidden', String(!active));
        slide.tabIndex = active ? 0 : -1;
      });
      dots.forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === index));
      if (previous) previous.disabled = index === 0;
      if (next) next.disabled = index === slides.length - 1;
    };

    previous?.addEventListener('click', () => goTo(index - 1));
    next?.addEventListener('click', () => goTo(index + 1));
    dots.forEach((dot) => dot.addEventListener('click', () => goTo(Number(dot.dataset.galleryDot))));

    gallery.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') goTo(index - 1);
      if (event.key === 'ArrowRight') goTo(index + 1);
    });

    track.addEventListener('pointerdown', (event) => {
      dragging = true;
      startX = event.clientX;
      dragX = 0;
      track.style.transition = 'none';
      track.setPointerCapture?.(event.pointerId);
    });

    track.addEventListener('pointermove', (event) => {
      if (!dragging) return;
      dragX = event.clientX - startX;
      track.style.transform = `translate3d(calc(-${index * 100}% + ${dragX}px), 0, 0)`;
    });

    const finishDrag = () => {
      if (!dragging) return;
      dragging = false;
      suppressClick = Math.abs(dragX) > 8;
      if (dragX < -55) goTo(index + 1);
      else if (dragX > 55) goTo(index - 1);
      else goTo(index);
      window.setTimeout(() => { suppressClick = false; }, 0);
    };

    track.addEventListener('pointerup', finishDrag);
    track.addEventListener('pointercancel', finishDrag);

    track.addEventListener('click', (event) => {
      const slide = event.target.closest('[data-gallery-slide]');
      if (!slide || suppressClick || !lightbox || !lightboxImage) return;
      lightboxImage.src = slide.dataset.zoomSrc;
      if (typeof lightbox.showModal === 'function') lightbox.showModal();
      else lightbox.setAttribute('open', '');
    });

    lightbox?.querySelector('[data-lightbox-close]')?.addEventListener('click', () => lightbox.close());
    lightbox?.addEventListener('click', (event) => {
      if (event.target === lightbox) lightbox.close();
    });

    goTo(0);
  }

  showToast(message) {
    const toast = document.querySelector('[data-cart-toast]');
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add('is-visible');
    window.clearTimeout(this.toastTimer);
    this.toastTimer = window.setTimeout(() => toast.classList.remove('is-visible'), 2600);
  }
}

document.addEventListener('DOMContentLoaded', () => new KarbonivaTheme());
